import axiosInstance from '@/services/axiosInstanceRehydrated'

async function getImageUser (internalNumber) {
  const data = { codigo: internalNumber, foto: '' }
  const req = {
    url: '/rgcc-services/FuncionesSW/TraerFotoSocio',
    method: 'POST',
    data
  }

  const res = await axiosInstance(req)

  return res.data ? res.data.foto : null
}

export {
  getImageUser
}
